module.exports = __webpack_public_path__ + "static/build-zambia-8b48950d161ab3e49b9cd6a0d0bafabd.svg";